/**
 * 匠人 接口的统一出口
 */
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const agents = {
  /** ***********普通用户BEGIN***************/
  // 列表
  list (params) {
    return axios.get(api + 'agents/list', {
      params: params
    })
  },
  // 待审列表
  reviewlist (params) {
    return axios.get(api + 'agents/reviewlist', {
      params: params
    })
  },
  // 审核
  review (params) {
    return axios.post(api + 'agents/review', qs.stringify(params))
  },
  detail (params) {
    return axios.get(api + 'agents/detail', {
      params: params
    })
  },
  remove (params) {
    return axios.post(api + 'agents/remove', qs.stringify(params))
  },
  edit (params) {
    return axios.post(api + 'agents/edit', qs.stringify(params))
  },
  // 分类列表
  cate (params) {
    return axios.get(api + 'agenttype/catelist', {
      params: params
    })
  },
  // 技艺列表
  skill (params) {
    return axios.get(api + 'agenttype/skilllist', {
      params: params
    })
  },
  reviewStatus (params) {
    return axios.post(api + 'agents/reviewStatus', qs.stringify(params))
  },
  // 2.代理商户下的用户列表
  agentuserlist (params) {
    return axios.get(api + 'agents/userlist', {
      params: params
    })
  },
  // 3.代理商下的商户
  agenttradesmanlist (params) {
    return axios.get(api + 'agents/tradesmanlist', {
      params: params
    })
  },
  createTradShowTradList (params) {
    return axios.post(api + 'agents/tradcreateTradShowTradList', qs.stringify(params))
  },
  // 4.删除商户
  tradesmanremove (params) {
    return axios.post(api + 'agents/tradesmanremove', qs.stringify(params))
  },
  // 5.获取提成记录
  tcrecord (params) {
    return axios.get(api + 'agents/tcrecord', {
      params: params
    })
  },
  // 8.提成详情
  recorddetail (params) {
    return axios.get(api + 'agents/recorddetail', {
      params: params
    })
  },
  // 10.生成二维码/海报
  agentqrcode (params) {
    return axios.post(api + 'agents/qrcode', qs.stringify(params))
  },
  //一级分销商导出收入记录
  exportfirstagentShouru (params) {
    return axios.post(api + 'export/firstagentShouru', qs.stringify(params))
  },
  //二级分销商
  exportagentShouru (params) {
    return axios.post(api + 'export/agentShouru', qs.stringify(params))
  },
  addtradqrcode (params) {
    return axios.post(api + 'agents/addtradqrcode', qs.stringify(params))
  },
  //二维码
  qrcodes (params) {
    return axios.get(api + 'agents/qrcodes', {
      params: params
    })
  },
  //通过该二维码扫进来的用户
  qrcodeuser (params) {
    return axios.get(api + 'agents/qrcodeuser', {
      params: params
    })
  },
  pushgoodinfo (params) {
    return axios.post(api + 'agents/push/goodinfo', qs.stringify(params))
  },
}

// 导出接口
export default agents
